import { useMutation } from 'react-query';
import {
  createCommunicationAsync,
  deleteCommunicationAsync,
  getCommunicationByIdAsync,
  updateCommunicationAsync,
} from '../../index';

export const useCreateCommunicationAsync = () =>
  useMutation(createCommunicationAsync);
export const useGetCommunicationByIdAsync = () =>
  useMutation(getCommunicationByIdAsync);
export const useUpdateCommunicationAsync = () =>
  useMutation(updateCommunicationAsync);
export const useDeleteCommunicationAsync = () =>
  useMutation(deleteCommunicationAsync);
